import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ClassNotebookLogoFill32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M720 1032V609l209-12v834l-205-12-256-445v431l-179-8V630l196-8 235 410zm1104-680h128v1344h-128v64h-640V288h640v64z" />
    </svg>
  ),
  displayName: 'ClassNotebookLogoFill32Icon',
});

export default ClassNotebookLogoFill32Icon;
